module.exports = __webpack_public_path__ + "img/lightcall.f17d1ac5.svg";